import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import {
  actionGetClientSettings,
  actionUpdateClientSettings,
} from "../../../redux/action/accessRights/actionCustomersSettings";
import { actionGetCustomersList } from "../../../redux/action/accessRights/actionCustomersList";
import { getDaysInMonth } from "../../../utils/getDaysInMonth";
import { AppDispatch } from "../../../redux/reducer/store";

import Loader from "../../custom/loader/loader";
import Select from "../../custom/select/select";

import "../table.scss";
import { IUserOptions } from "../../../types/interfaces";

// const desktopOptions = [
//   { value: "default", label: "Демонстрационный" },
// ];
//
// const chartsOptions = [
//   { value: 'visit', label: 'Визиты (План/Факт)' },
//   { value: 'oss', label: 'OSS' },
//   { value: 'mediumFace', label: 'Средний фейсинг' },
//   { value: 'actions', label: 'Акции: стартовала/не стартовала' },
//   { value: 'rateStatus', label: 'Статусы оценки' },
//   { value: 'checkStatus', label: 'Статусы проверки' },
//   { value: 'facing', label: 'Фэйсинг' },
//   { value: 'dynamics', label: 'Динамика % качества отчётов' },
//   { value: 'reportsChart', label: 'Отчёты проверен/не проверен' },
// ];

const reviewStatusesOptions = [
  { value: "NotChecked", label: "Не проверен" },
  { value: "Fixed", label: "Исправлен" },
  { value: "Approved", label: "Утвержден" },
  { value: "Revision", label: "Доработка" },
  { value: "Improved", label: "Доработан" },
  { value: "PartiallyRejected", label: "Отклонен (частично)" },
  { value: "Rejected", label: "Отклонен" },
];

const monthOptions = [
  { value: 1, label: "январь" },
  { value: 2, label: "февраль" },
  { value: 3, label: "март" },
  { value: 4, label: "апрель" },
  { value: 5, label: "май" },
  { value: 6, label: "июнь" },
  { value: 7, label: "июль" },
  { value: 8, label: "август" },
  { value: 9, label: "сентябрь" },
  { value: 10, label: "октябрь" },
  { value: 11, label: "ноябрь" },
  { value: 12, label: "декабрь" },
];

const startYear = 1900;
const endYear = 2100;
const yearOptions = Array.from({ length: endYear - startYear + 1 }, (_, i) => ({
  value: startYear + i,
  label: (startYear + i).toString(),
}));

const TableCustomerSettings: FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams<{ id: string }>();
  const {
    declineStartPeriodsOptions,
    selectedReportDelayOption,
    selectedStartPeriodOption,
    declineEndPeriodsOptions,
    selectedEndPeriodOption,
    showReportCheckTypes,
    acceptReviewReasons,
    reportDelaysOptions,
    reviewStatusesValue,
    // customerInputValues,
    hideTraineeReports,
    regionRestriction,
    multiReviewReason,
    settingsForUpdate,
    onlyPhotoAndGeo,
    clientSettings,
    fixByNextVisit,
    reviewHistory,
    visitSchedule,
    averageFacing,
    shareOfShelf,
    reviewStatus,
    hidePhotoGeo,
    analytics,
    periodOsa,
    customers,
    fixHours,
    reviewer,
    posMap,
    limit,
    pages,
    geo,
    analyticsHideRubles,
    showReportCostPercent
  } = useSelector((state: any) => state.roles.customerList);
  const { isOpenSidebar } = useSelector((state: IUserOptions) => state.user.user);
  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);
  const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);
  const [selectedSettings, setSelectedSettings] = useState<any>();
  const [isPending, setIsPending] = useState<boolean>(false);

  const reportsFromDate =
    selectedSettings &&
    selectedSettings?.reportsFrom
      .split("-")
      .reverse()
      .map((elem: string) => parseFloat(elem));
  const numberOfDaysInMonth = (reportsFromDate && reportsFromDate.length >= 3) && getDaysInMonth(reportsFromDate[2], reportsFromDate[1]);
  const dayOptions = Array.from({ length: numberOfDaysInMonth }, (_, i) => ({
    value: i + 1,
    label: (i + 1).toString(),
  }));

  const initialStatuses = reviewStatusesOptions.map((option) => option.value);
  // const chartsLabels = customerInputValues.chartsList
  //   ?.map((el: string) => {
  //     const findItem = chartsOptions.find((item: { value: string, label: string }) => item.value === el);
  //     return findItem ? findItem.label : null;
  //   });

  useEffect(() => {
    if (!clientSettings) {
      dispatch(actionGetClientSettings(id));
    } else {
      setSelectedSettings(settingsForUpdate);
    }
  }, [clientSettings, dispatch, id, settingsForUpdate]);

  useEffect(() => {
    if (!customers) {
      dispatch(actionGetCustomersList(limit, pages));
    }
  }, [customers, dispatch, limit, pages]);

  useEffect(() => {
    if (reviewStatusesValue) {
      setSelectedStatuses(reviewStatusesValue);
    }
  }, [reviewStatusesValue]);

  const handleChangeAllStatusesCheckbox = () => {
    const updatedStatuses =
      selectedStatuses.length === reviewStatusesOptions.length
        ? []
        : initialStatuses;
    const updatedSettings = {
      ...selectedSettings,
      reviewStatuses: {
        value: updatedStatuses,
      },
    };

    setSelectedStatuses(updatedStatuses);
    setSelectedSettings(updatedSettings);
  };

  const handleChangeStatusCheckbox = (value: string) => {
    let updatedStatuses = [...selectedStatuses];

    if (selectedStatuses.includes(value)) {
      updatedStatuses = updatedStatuses.filter((status) => status !== value);
    } else {
      updatedStatuses.push(value);
    }

    const updatedSettings = {
      ...selectedSettings,
      reviewStatuses: {
        value: updatedStatuses,
      },
    };

    setSelectedStatuses(updatedStatuses);
    setSelectedSettings(updatedSettings);
  };

  const handleChangeCheckbox = (name: string) => {
    const updatedSettings = {
      ...selectedSettings,
      [name]: !selectedSettings[name],
    };
    setSelectedSettings(updatedSettings);
    dispatch(actionUpdateClientSettings(id, updatedSettings));
  };
  const handleSelectChange = (event: { value: number, label: string }, name: string) => {
    const updatedSettings = {
      ...selectedSettings,
      [name]: {
        value: event.value,
      },
    };

    setSelectedSettings(updatedSettings);
  };

  const handleChangeDateSelect = (event: { value: number, label: string }, name: string) => {
    const updatedSettings = { ...selectedSettings };
    let newDate = [...reportsFromDate].map((elem: any) => {
      if (elem < 10) {
        return `0${elem}`;
      } else {
        return elem.toString();
      }
    });

    if (name === "day") {
      newDate[0] = event.value < 10 ? `0${event.value}` : `${event.value}`;
    } else if (name === "month") {
      const monthDays = getDaysInMonth(parseFloat(newDate[2]), event.value);
      if (monthDays < newDate[0]) {
        newDate[0] = monthDays;
      }
      newDate[1] = event.value < 10 ? `0${event.value}` : `${event.value}`;
    } else if (name === "year") {
      newDate[2] = `${event.value}`;
    }

    updatedSettings.reportsFrom = newDate.reverse().join("-");
    setSelectedSettings(updatedSettings);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>,) => {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;
    if (!/^[\d.]*\.?\d{0,2}$/.test(value)) {
      return;
    } else {
      const updatedSettings = {
        ...selectedSettings,
        ...(name === 'autoDeleteOrdersInDaysExcel'
          ? {
            autoDeleteOrdersInDaysExcel: parseFloat(value),
            autoDeleteOrdersInDaysZip: parseFloat(value)
          }
          : { [name]: parseFloat(value) }
        )
      };

      setSelectedSettings(updatedSettings);
    }
  };

  const handleClickSaveBtn = () => {
    setIsPending(true);
    dispatch(actionUpdateClientSettings(id, selectedSettings)).then(() => {
      setIsPending(false);
    });
  };

  useEffect(() => {
    if (selectedSettings && selectedSettings.reviewStatuses.value === undefined) {
      const updatedSettings = {
        ...selectedSettings,
        reviewStatuses: {
          value: [],
        },
      };
      setSelectedSettings(updatedSettings);
    }
  }, [selectedSettings])
  return (
    <div className={isOpenSidebar ? 'active__wrapper' : 'closed__wrapper'}>
      <div className="loader__wrapper">
        {(!customers || isPending) && <Loader />}
      </div>
      <div className="settings__tables_block">
        <div className="client__settings_table">
          <span className="section__title inside">
            Настройка дат выгрузки отчетов и времени доступа
          </span>
          <div className="client__settings_filterBlock inside">
            <span>Показывать и выгружать отчеты начиная с</span>
            <div className="settings__filterBlock_children">
              <div className="settings__day_select">
                {reportsFromDate && (
                  <Select
                    disabled={!(claims.includes('admin') ||
                      claims.includes('customers:edit'))}
                    propsChange={(event: { value: number, label: string }) =>
                      handleChangeDateSelect(event, "day")
                    }
                    value={dayOptions.find(
                      (elem: { value: number, label: string }) => elem.value === reportsFromDate[0]
                    )}
                    options={dayOptions}
                  />
                )}
              </div>
              <div className="settings__month_select">
                {reportsFromDate && (
                  <Select
                    disabled={!(claims.includes('admin') ||
                      claims.includes('customers:edit'))}
                    propsChange={(event: { value: number, label: string }) =>
                      handleChangeDateSelect(event, "month")
                    }
                    defaultValue={monthOptions.find(
                      (elem: { value: number, label: string }) => elem.value === reportsFromDate[1]
                    )}
                    options={monthOptions}
                  />
                )}
              </div>
              <div className="settings__year_select">
                {reportsFromDate && (
                  <Select
                    disabled={!(claims.includes('admin') ||
                      claims.includes('customers:edit'))}
                    propsChange={(event: { value: number, label: string }) =>
                      handleChangeDateSelect(event, "year")
                    }
                    defaultValue={yearOptions.find(
                      (elem: { value: number, label: string }) => elem.value === reportsFromDate[2]
                    )}
                    options={yearOptions}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="client__settings_filterBlock inside">
            <span className={'inside'}>Автоудаление выгрузок, дней</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') || claims.includes('customers:edit'))}
                onChange={handleInputChange}
                value={selectedSettings ? selectedSettings.autoDeleteOrdersInDaysExcel.toString() : ''}
                className="settings__filterBlock_input"
                name="autoDeleteOrdersInDaysExcel"
                type="number"
                min={0}
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Отчеты видны спустя</span>
            <div className="settings__filterBlock_column">
              {selectedReportDelayOption && (
                <Select
                  disabled={!(claims.includes('admin') ||
                    claims.includes('customers:edit'))}
                  propsChange={(event: { value: number, label: string }) =>
                    handleSelectChange(event, "reportsDelay")
                  }
                  defaultValue={selectedReportDelayOption}
                  options={reportDelaysOptions}
                />
              )}
              <span>После их создания</span>
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Может отклонять отчеты</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("reviewer")}
                defaultChecked={reviewer}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Может отклонять через</span>
            <div className="settings__filterBlock_column">
              {selectedStartPeriodOption && (
                <Select
                  disabled={!(claims.includes('admin') ||
                    claims.includes('customers:edit'))}
                  propsChange={(event: { value: number, label: string }) =>
                    handleSelectChange(event, "declinePeriodStart")
                  }
                  defaultValue={selectedStartPeriodOption}
                  options={declineStartPeriodsOptions}
                />
              )}
              <span>После их создания</span>
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Может отклонять в течении</span>
            <div className="settings__filterBlock_column">
              {selectedEndPeriodOption && (
                <Select
                  disabled={!(claims.includes('admin') ||
                    claims.includes('customers:edit'))}
                  propsChange={(event: { value: number, label: string }) =>
                    handleSelectChange(event, "declinePeriodEnd")
                  }
                  defaultValue={selectedEndPeriodOption}
                  options={declineEndPeriodsOptions}
                />
              )}
              <span>После разрешения</span>
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Может смотреть координаты</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("geo")}
                defaultChecked={geo}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Ограничение по регионам</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("regionRestriction")}
                defaultChecked={regionRestriction}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Ограничение по статусам</span>
            <div className="settings__filterBlock_column">
              <div className="settings__statuses_elem">
                <input
                  disabled={!(claims.includes('admin') ||
                    claims.includes('customers:edit'))}
                  checked={
                    selectedStatuses.length === reviewStatusesOptions.length
                  }
                  onChange={handleChangeAllStatusesCheckbox}
                  type="checkbox"
                />
                <span>Все</span>
              </div>
              {reviewStatusesOptions.map((elem: { value: string, label: string }, index: number) => (
                <div className="settings__statuses_elem" key={index}>
                  <input
                    disabled={!(claims.includes('admin') ||
                      claims.includes('customers:edit'))}
                    onChange={() => handleChangeStatusCheckbox(elem.value)}
                    checked={selectedStatuses.includes(elem.value)}
                    type="checkbox"
                  />
                  <span>{elem.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="client__settings_table">
          <div className="client__settings_filterBlock">
            <span>Выбор типа проверки</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("showReportCheckTypes")}
                defaultChecked={showReportCheckTypes}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Выбор критериев при принятии отчета</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("acceptReviewReasons")}
                defaultChecked={acceptReviewReasons}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Просмотр графика визитов</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("visitSchedule")}
                defaultChecked={visitSchedule}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Показывать статус проверки отчетов</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("reviewStatus")}
                defaultChecked={reviewStatus}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Показывать историю изменения статуса проверки отчетов</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("reviewHistory")}
                defaultChecked={reviewHistory}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Скрыть данные, только фото и гео</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("onlyPhotoAndGeo")}
                defaultChecked={onlyPhotoAndGeo}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Количество часов на претензию</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onChange={handleInputChange}
                defaultValue={
                  (selectedSettings && selectedSettings.fixHours) || fixHours
                }
                className="settings__filterBlock_input"
                name="fixHours"
                type="number"
                min={0}
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Срок исправления претензии до следующего визита</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("fixByNextVisit")}
                defaultChecked={fixByNextVisit}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Не показывать отчеты с фиолетовой гео</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("hidePhotoGeo")}
                defaultChecked={hidePhotoGeo}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Множественный выбор причин для формирования претензии</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("multiReviewReason")}
                defaultChecked={multiReviewReason}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>OSA за период</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("periodOsa")}
                defaultChecked={periodOsa}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Средний фейсинг за период</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("averageFacing")}
                defaultChecked={averageFacing}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Доля полки</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("shareOfShelf")}
                defaultChecked={shareOfShelf}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Скрывать отчёты стажёров до проверки</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("hideTraineeReports")}
                defaultChecked={hideTraineeReports}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Карта обслуживания</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("posMap")}
                defaultChecked={posMap}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Доступен раздел "Аналитика"</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("analytics")}
                defaultChecked={analytics}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Скрыть стоимость, руб. в диаграммах</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("analyticsHideRubles")}
                defaultChecked={analyticsHideRubles}
                type="checkbox"
              />
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Отображать стоимость факт, %</span>
            <div className="settings__filterBlock_children">
              <input
                disabled={!(claims.includes('admin') ||
                  claims.includes('customers:edit'))}
                onClick={() => handleChangeCheckbox("showReportCostPercent")}
                defaultChecked={showReportCostPercent}
                type="checkbox"
              />
            </div>
          </div>

          {/*<div className="client__settings_filterBlock">*/}
          {/*  <span>Рабочий стол (по умолчанию)</span>*/}
          {/*  <div className="settings__filterBlock_column">*/}
          {/*    <Select*/}
          {/*      propsChange={(event: { value: number, label: string }) =>*/}
          {/*        handleChangeDateSelect(event, "desktop")*/}
          {/*      }*/}
          {/*      value={{name: '', label: 'Демонстративный'}}*/}
          {/*      options={desktopOptions}*/}
          {/*    />*/}
          {/*  </div>*/}
          {/*</div>*/}
          {/*<div className="client__settings_filterBlock">*/}
          {/*  <span>Диаграммы</span>*/}
          {/*  <div className="settings__filterBlock_children">*/}
          {/*    <div className='multiselect__filter_block' style={{ width: "100%" }}>*/}
          {/*      <CustomMultiSelect*/}
          {/*        setLoading={() => { }}*/}
          {/*        inputValues={customerInputValues}*/}
          {/*        options={chartsOptions}*/}
          {/*        isShowPlaceholder={true}*/}
          {/*        pageName='mapTypes1'*/}
          {/*        placeholder='Тип'*/}
          {/*        name='chartsList'*/}
          {/*        limit={0}*/}
          {/*        reducer={reducerEmployeesInputValues}*/}
          {/*        resetPages={() => { }}*/}
          {/*        action={actionTest}*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
          {/*{chartsLabels?.length > 0 && <span className="client__settings_span">{chartsLabels.join(', ')}</span>}*/}
        </div>
      </div>
      {(claims.includes('admin') ||
        claims.includes('customers:edit')) && <button onClick={handleClickSaveBtn} className="save__button">
          Сохранить
        </button>}
    </div>
  );
};

export default TableCustomerSettings;
